import React, { Component } from 'react';
import {connect} from 'react-redux'
import { Button, FormControl, FormGroup, ControlLabel, ButtonToolbar } from 'react-bootstrap';
import { Box } from 'reactjs-admin-lte';
import FontAwesome from 'react-fontawesome';
// import { render } from 'react-dom';
import WorkdocStore from '../../stores/WorkdocStore'

var NotificationSystem = require('react-notification-system');
class SWTWorkNote extends Component {

  constructor(props) {
    super(props)

    this.state = {loading:false,record:''}
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    this.loadData()
  }

  loadData() {
		let {record} = this.state
		let {mode} = this.props
		this.setState({loading:true})
		if (mode==='assetwork') {
			WorkdocStore.loadAssetWorkRelated(this.props.workNo,'work_note',(result)=>{
				if (result.data===undefined||result.data.record_text===undefined)
					record = ''
				else
					record = result.data.record_text
				this.setState({loading:false,record:record})			
			})
		} else {
			WorkdocStore.loadWorkdocRelated(this.props.workNo,'work_note',(result)=>{
				if (result.data===undefined||result.data.record_text===undefined)
					record = ''
				else
					record = result.data.record_text
				this.setState({loading:false,record:record})			
			})
		}	
  }

  onTextChange(e) {
  	// let {record} = this.state
  	this.setState({record:e.target.value})
  }

  onSaveClick() {
  	let {record} = this.state
  	let {workNo,mode} = this.props
		let postData = {record_text:record}
		if (mode==='assetwork') {
			WorkdocStore.saveAssetWorkRelated(workNo,'work_note',postData,(result)=>{
				this._notificationSystem.addNotification({
					title: 'แจ้งเตือน',
					message: 'ทำการบันทึกรายละเอียดเอกสารประกอบเลขงานซ่อม ' + workNo + ' เรียบร้อย',
					level: 'info',
					position: 'tc',        
				})
			},(result) => {
				this._notificationSystem.addNotification({
					title: 'แจ้งเตือน',
					message: 'มีความผิดพลาดเกิดขึ้นในการบันทึกเอกสารประกอบเลขงานซ่อม ' + workNo + ' ',
					level: 'error',
					position: 'tc'
				})
			})
		} else {	
			WorkdocStore.saveWorkdocRelated(workNo,'work_note',postData,(result)=>{
				this._notificationSystem.addNotification({
					title: 'แจ้งเตือน',
					message: 'ทำการบันทึกรายละเอียดเอกสารประกอบเลขงานซ่อม ' + workNo + ' เรียบร้อย',
					level: 'info',
					position: 'tc',        
				})
			},(result) => {
				this._notificationSystem.addNotification({
					title: 'แจ้งเตือน',
					message: 'มีความผิดพลาดเกิดขึ้นในการบันทึกเอกสารประกอบเลขงานซ่อม ' + workNo + ' ',
					level: 'error',
					position: 'tc'
				})
			})
		}	
  }

  render() {
  	let {loading,record} = this.state
  	return(
  		<div>
  			<Box loading={loading}>
		        <Box.Body>
		          <form>
					<FormGroup controlId="formControlsTextarea">
					  <ControlLabel>บันทึกช่วยจำ</ControlLabel>
					  <FormControl 
					   componentClass="textarea" 
					   placeholder="" 
					   rows={10}
					   value={record}
					   onChange={this.onTextChange.bind(this)}
					  />
					</FormGroup>
				  </form>    
		        </Box.Body>
		        <Box.Footer>
		          <ButtonToolbar className='pull-right'>
		            <Button className='btn btn-primary' onClick={this.onSaveClick.bind(this)}><FontAwesome name='save' />&nbsp;บันทึก</Button>  
		          	<Button className='btn btn-default' onClick={()=>this.setState({record:''})}><FontAwesome name='close' />&nbsp;ล้างข้อความ</Button>
          		  </ButtonToolbar>
		        </Box.Footer>
  			</Box>
  			<NotificationSystem ref="notificationSystem" />
  		</div>
  	)
  }
}    

SWTWorkNote.defaultProps = {
	mode: ''
}

export default SWTWorkNote = connect(
  (state) => ({messages: state.message.view.workdoc.SWTWorkNote}),null,null,{withRef:true}
)(SWTWorkNote);


// WEBPACK FOOTER //
// ./src/view/workdoc/SWTWorkNote.js